// core
import React from 'react';

// settings + utils
import Settings from 'config.js';
import Auth from 'services/Auth.js';
import API from 'utils/API.js';
import CSV from 'utils/CSV.js';

// lib
import Page from 'pages/shared/Page';
import Spinner from 'components/shared/Spinner';
import SchoolsUtil from 'utils/SchoolsUtil';

import FiltersToolbar from 'components/shared/filters/FiltersToolbar';
import KitOrdersList from 'components/kit-orders/details/KitOrdersList';

class CopyPastePage extends React.Component {
  constructor(props) {
    super(props);

    this.DEFAULT_STATE = {
      fetching: false,
      error: '',

      currStep: 1,
      showInstructions: true,

      cache: [], // cache of requests

      sourceKitId: null,
      sourceKitName: '',
      destKitId: null,
      destKitName: '',

      // filters
      filters: {
        schooltypes: [],

        schoolyears: [],

        locations: [],

        projects: [],
        productGroups: [],
        products: []
      },
      showFiltersRestoreNotice: false,
      searchKey: '',

      // data options
      allowShipped: 0,
      allowCopied: 0,

      // this is the object(s) before any filtering/search
      fetchedData: {},

      // current object(s)
      currData: {
        orders: [],

        sortBy: 'id',
        sortDir: 'ASC',

        // offset: 0,
        // limit: 500
      },

      selected: [],
      numKits: 0, // how many kits are we aiming for, as int
      numProcessed: 0, // operations left
      move: 0, // whether we're moving or copying, as int

      numTotalJobs: 0,
      numJobsProcessed: 0,
      numErrorsByMessage: {},

      numCopiedKits: 0
    };

    this.state = this.DEFAULT_STATE;

    this.START_YEAR = (new Date()).getFullYear() - 2; // don't go beyond this year

    this.STATUS_ON_HOLD = 'ON_HOLD';
    this.STATUS_REFUSED = 'REFUSED';
    this.STATUS_SHIPPED = 'SHIPPED';

    this.sendHttpRequest = this.sendHttpRequest.bind(this);
    this.handleFilters = this.handleFilters.bind(this);
    this.handleAllowShippedChange = this.handleAllowShippedChange.bind(this);
    this.handleAllowCopiedChange = this.handleAllowCopiedChange.bind(this);
    this.refreshOrders = this.refreshOrders.bind(this);

    this.handleSelectOrder = this.handleSelectOrder.bind(this);
    this.handleClearOrder = this.handleClearOrder.bind(this);
    this.selectAll = this.selectAll.bind(this);
    this.deselectAll = this.deselectAll.bind(this);

    this.handleNumKitsChange = this.handleNumKitsChange.bind(this);
    this.handleMoveChange = this.handleMoveChange.bind(this);

    this.handleStep1Submit = this.handleStep1Submit.bind(this);
    this.handleStep2Submit = this.handleStep2Submit.bind(this);
    this.handleDismissInstructions = this.handleDismissInstructions.bind(this);

    this.reset = this.reset.bind(this);
  }

  // make queueable requests
  sendHttpRequest(method, url, data) {
    return new Promise(function (resolve, reject) {
      var xhr = new XMLHttpRequest();

      xhr.open(method, url);
      xhr.setRequestHeader("Content-Type", "application/json");
      xhr.onload = function () {
        if (this.status >= 200 && this.status < 300) {
          resolve(JSON.parse(xhr.response));
        } else {
          reject({
            status: this.status,
            statusText: xhr.statusText
          });
        }
      };

      xhr.onerror = function () {
        reject({
          status: this.status,
          statusText: xhr.statusText
        });
      };

      xhr.send(JSON.stringify(data));
    });
  }

  handleDismissInstructions() {
    this.setState({
      showInstructions: false
    });
  }

  handleFilters(data) {
    this.setState({
      filters: data
    }, () => {
      // save for later
      const currFiltersJSON = JSON.stringify(data);
      window.localStorage.setItem('colibri:copy-past-kit-orders:filters', currFiltersJSON);

      this.refreshOrders();
    });
  }

  handleAllowShippedChange(e) {
    this.setState({
      allowShipped: parseInt(e.currentTarget.value)
    }, () => {
      this.refreshOrders();
    });
  }
  handleAllowCopiedChange(e) {
    this.setState({
      allowCopied: parseInt(e.currentTarget.value)
    }, () => {
      this.refreshOrders();
    });
  }

  refreshOrders() {
    if (!this.state.fetchedData.shippable_orders || !this.state.fetchedData.shippable_orders.length) {
      console.error('No orders in fetchedData');

      return;
    }

    console.log('Refresh orders (will dump allowShipped/allowCopied)', this.state.allowShipped, this.state.allowCopied);

    this.deselectAll();

    // filter orders
    let ordersFiltered = [];
    this.state.fetchedData.shippable_orders.forEach((order) => {
      console.log('Process order', order.id);

      // filter by school types
      let schooltypesOK = false;

      if (order.school_type) {
        if (this.state.filters.schooltypes && this.state.filters.schooltypes.length) {
          for (let i=0; i<this.state.filters.schooltypes.length; i++) {
            let schooltype = this.state.filters.schooltypes[i];

            const typeGroups = SchoolsUtil.getSchoolclassGroupsFromType(order.school_type);
            if (typeGroups.indexOf(schooltype) != -1) {
              schooltypesOK = true;

              break;
            }
          }
        } else {
          schooltypesOK = true;
        }
      } else {
        // console.error('NO school type!');
      }

      // filter by locations
      let locationsOK = false;
      if (this.state.filters.locations.length && order.school) {
        for (let i=0; i<this.state.filters.locations.length; i++) {
          const locationId = this.state.filters.locations[i];
          const school = order.school;

          if (order.school_region_id == locationId || order.school_province_id == locationId || order.school_city_id == locationId) {
            locationsOK = true;

            break;
          }

          if (locationsOK) {
            break;
          }
        }
      } else {
        locationsOK = true;
      }

      // filter by shipped
      let shippedOK = false;
      if (this.state.allowShipped) {
        console.log('Will allow since allowShipped is true');

        shippedOK = true;
      } else {
        // there should be at least 1 unshipped item
        for (let i=0; i<order.items.length; i++) {
          let item = order.items[i];

          const itemStatus = item.status.toUpperCase();

          if (itemStatus != this.STATUS_REFUSED && itemStatus != this.STATUS_SHIPPED) {
            console.log('Will allow since item ' + item.id + ' status is: ' + itemStatus);

            shippedOK = true;

            break;
          }
        }
      }

      // filter by copied
      let copiedOK = false;
      if (this.state.allowCopied) {
        copiedOK = true;
      } else {
        // there should be at least 1 uncopied item
        for (let i=0; i<order.items.length; i++) {
          let item = order.items[i];

          if (!item.clone_of) {
            copiedOK = true;

            break;
          }
        }
      }

      if (schooltypesOK && locationsOK && shippedOK && copiedOK) {
        ordersFiltered.push(order);
      }
    });

    // sort
    // ordersFiltered = this.sort(ordersFiltered);

    this.setState((prevState) => {
      prevState.currData.orders = ordersFiltered;
      prevState.currData.offset = 0;

      return prevState;
    }, () => {
      this.selectAll();
    });
  }

  handleSelectOrder(order) {
    this.setState((prevState) => {
      prevState.selected.push(order.id);

      return prevState;
    });
  }
  handleClearOrder(order) {
    this.setState((prevState) => {
      const index = prevState.selected.indexOf(order.id);
      prevState.selected.splice(index, 1);

      return prevState;
    });
  }
  selectAll() {
    this.state.currData.orders.forEach((order) => {
      this.handleSelectOrder(order);
    });
  }
  deselectAll() {
    this.state.currData.orders.forEach((order) => {
      this.handleClearOrder(order);
    });
  }

  handleNumKitsChange(e) {
    const val = e.currentTarget.value;

    this.setState({
      numKits: val
    });
  }

  handleMoveChange(e) {
    const val = e.currentTarget.value;

    this.setState({
      move: val
    });
  }

  handleStep1Submit() {
    var sourceKitDropdown = document.querySelector('[name="source_kit_id"]');
    var destKitDropdown = document.querySelector('[name="dest_kit_id"]');

    this.setState({
      fetching: true,

      currStep: 2,

      sourceKitId: sourceKitDropdown.value,
      sourceKitName: sourceKitDropdown.options[sourceKitDropdown.selectedIndex].text,

      destKitId: destKitDropdown.value,
      destKitName: destKitDropdown.options[destKitDropdown.selectedIndex].text,

      fetchedData: {},
    });

    // get results
    API.call('GET', Settings.V3_API_URL + '/reports/copy-paste?src=' + sourceKitDropdown.value + '&dest=' + destKitDropdown.value + '&offset=0&limit=-1&access_token=' + Auth.getToken(), {}, (response, error) => {
      if (error) {
        this.setState({
          fetching: false,
          error: error.message + ' while getting fetchedData'
        });

        return false;
      }

      this.setState((prevState) => {
        prevState.fetching = false;

        prevState.fetchedData.src_kit = response.data.src_kit;
        prevState.fetchedData.dest_kit = response.data.dest_kit;
        prevState.fetchedData.shippable_orders = response.data.shippable_orders;

        return prevState;
      }, () => {
        this.refreshOrders();
      });
    });
  }

  handleStep2Submit() {
    this.setState({
      fetching: true,

      currStep: 3
    });

    var numKits = this.state.numKits;

    let numProcessedKits = 0;
    let jobs = [];
    this.state.currData.orders.forEach((order) => {
      let items = [];

      order.items.forEach((item) => {
        let shouldProcess = false;
        const n = Math.ceil(item.schoolclass_num_students / this.state.fetchedData.dest_kit.num_served);

        const itemStatus = item.status.toUpperCase();

        if (!item.clone_of || this.state.allowCopied) { // only process if allowed
          if (!item.shippable) {
            if (this.state.selected.indexOf(order.id) != -1) {
              shouldProcess = true;
            }
          }
          if (item.shippable && itemStatus == this.STATUS_SHIPPED) {
            if (this.state.allowShipped) { // only count if allowed
              if (this.state.selected.indexOf(order.id) != -1) {
                shouldProcess = true;
              }
            }
          }
          if (item.shippable && itemStatus != this.STATUS_SHIPPED) {
            if (this.state.selected.indexOf(order.id) != -1) {
              shouldProcess = true;
            }
          }
        }

        if (shouldProcess && numProcessedKits < numKits) {
          items.push(item);

          numProcessedKits += n;
        }
      });

      if (items.length > 0) {
        // create new order in dest kit
        jobs.push({
          order: order,
          kit: this.state.fetchedData.dest_kit,
          items: items
        });
      }
    });

    console.log('HAVE JOBS (will dump)', jobs);

    const processJob = (job, callback) => {
      console.log(`[${job.order.id}/1] START job...`);

      let errorMessages = [];

      // 1/3: first, create order
      const orderPayload = {
        "teacher_subject": job.order.teacher_subject,
        "teacher_first_name": job.order.teacher_first_name,
        "teacher_last_name": job.order.teacher_last_name,
        "teacher_email": job.order.teacher_email,
        "teacher_phone": job.order.teacher_phone,

        "school_id" : job.order.school_id,

        "user_provided_school_school_type": job.order.user_provided_school_type,
        "user_provided_school_name": job.order.user_provided_school_name,
        "user_provided_school_address": job.order.user_provided_school_address,
        "user_provided_school_city": job.order.user_provided_school_city_name,
        "user_provided_school_zip_code": job.order.user_provided_school_zip_code,
        "user_provided_school_postcode": job.order.user_provided_school_postcode,
        "user_provided_school_province": job.order.user_provided_school_province_name,
        "user_provided_school_region": job.order.user_provided_school_region_name,
        "user_provided_school_phone": job.order.user_provided_school_phone,
        "user_provided_school_fax": job.order.user_provided_school_fax,
        "user_provided_school_email": job.order.user_provided_school_email,
        "user_provided_school_manager": job.order.user_provided_school_manager,
        "user_provided_school_manager": job.order.user_provided_school_school_manager,

        "extra_value_str": job.order.extra_value_str,
        "extra_value_int": job.order.extra_value_int,

        "clone_of": job.order.id,

        "submitted_at": job.order.submitted_at
      };

      let orderId = '';
      const orderEndpoint = Settings.V3_API_URL.replace(/\/+$/, '') + '/kit-orders';
      this.sendHttpRequest('POST', orderEndpoint, orderPayload)
        .then((response) => {
          if (!response.ok || !response.data || !response.data.order_id) {
            throw Error((response.error || 'generic error') + ' while creating order');
          }

          // otherwise, create items
          orderId = response.data.order_id;

          console.log(`[${job.order.id}/2] Will create ${job.items.length} items...`);

          let itemsEndpoint = Settings.V3_API_URL.replace(/\/+$/, '') + '/kit-orders/' + orderId + '/items';

          let numProcessed = 0;
          job.items.forEach((originalItem) => {
            let itemsPayload = Object.assign({}, originalItem);

            // reset some data + set to dest kit
            itemsPayload.status = this.STATUS_ON_HOLD;
            itemsPayload.kit_id = this.state.fetchedData.dest_kit.id;
            itemsPayload.product_id = this.state.fetchedData.dest_kit.id;
            itemsPayload.clone_of = originalItem.id;

            this.sendHttpRequest('POST', itemsEndpoint, itemsPayload)
              .then((response) => {
                if (!response.ok || !response.data || !response.data.item || !response.data.item.id) {
                  // if error creating item, log message
                  const errorMessage = (response.error || 'HTTP error') + ' while creating item';

                  throw Error(errorMessage);
                } else {
                  // otherwise, move if needed or continue/break if done
                  const handleDone = (response) => {
                    const numStudents = response.data.item.schoolclass_num_students;
                    const numCopiedKits = Math.ceil(numStudents / this.state.fetchedData.dest_kit.num_served);
                    console.log('YAY! Just copied some kits (will dump # students/kits/num served', numStudents, numCopiedKits, this.state.fetchedData.dest_kit.num_served);

                    this.setState((prevState) => {
                      prevState.numCopiedKits += numCopiedKits;

                      return prevState;
                    });
                  };

                  if (this.state.move) {
                    // if required, mark original item as "refused"—which basically means we've moved the item
                    let moveItemEndpoint = Settings.V3_API_URL.replace(/\/+$/, '') + '/kit-orders/' + job.order.id + '/items/' + originalItem.id;
                    let moveItemPayload = Object.assign({}, originalItem);
                    moveItemPayload.product_id = moveItemPayload.kit_id;
                    moveItemPayload.status = this.STATUS_REFUSED;

                    API.call('PUT', moveItemEndpoint, moveItemPayload, (response, error) => {
                      if (error || !response.ok) {
                        const errorMessage = (response.error || 'HTTP error') + ' while moving item';

                        throw Error(errorMessage);
                      }

                      handleDone(response);
                    });
                  } else {
                    handleDone(response);
                  }
                }
              })
              .catch((error) => {
                const errorMessage = error.message || 'HTTP error while creating item';
                errorMessages.push(errorMessage);

                console.log('ITEM ERROR CAUGHT: ', errorMessage);
              })
              .finally(() => {
                numProcessed++;

                if (numProcessed == job.items.length) {
                  console.log('CALLBACK (all items done)');
                  if (callback) callback(errorMessages);
                }
              });
          });
        })
        .catch((error) => {
          const errorMessage = error.message || 'HTTP error while creating order';
          errorMessages.push(errorMessage);

          console.log('CALLBACK (order error)');
          if (callback) callback(errorMessages)
        });
    };

    // now, update state w/ count + actually process jobs
    this.setState({
      fetching: true,
      numTotalJobs: jobs.length,
      numCopiedKits: 0
    }, () => {
      for (let i=0; i<jobs.length; i++) {
        processJob(jobs[i], (errorMessages) => {
          console.log('JOB #' + i + ' PROCESSED');
          console.log('JOB ERROR(S)', errorMessages);

          this.setState((prevState) => {
            if (errorMessages.length) {
              errorMessages.forEach((errorMessage) => {
                prevState.numErrorsByMessage[errorMessage] = typeof prevState.numErrorsByMessage[errorMessage] != 'undefined' ? prevState.numErrorsByMessage[errorMessage] + 1 : 1
              });
            }
            prevState.numJobsProcessed++;

            if (prevState.numJobsProcessed == jobs.length) {
              console.log('ALL JOBS PROCESSED');
              prevState.fetching = false;
            }

            return prevState;
          });
        });
      }
    });
  }

  reset() {
    let newState = this.DEFAULT_STATE;
    newState.showInstructions = false;

    this.setState(this.DEFAULT_STATE);
  }

  render() {
    // create a collection of kits sorted by year
    let kitsByKey = {};
    let kits = [];

    this.props.appData.cache.kits.forEach((kit) => {
      if (kit.schoolyear > this.START_YEAR) {
        let key = `${kit.schoolyear}_${kit.name}`;

        kitsByKey[key] = kit;
      }
    });
    Object.keys(kitsByKey).sort().forEach((key) => {
      kits.push(kitsByKey[key]);
    });

    var kitsDropdown = kits.map((kit) => {
      return <option value={kit.id}>{`A.S. ${kit.schoolyear} - ${kit.name} (in "${kit.group.name}")`}</option>
    });

    var currStepUI;

    switch (this.state.currStep) {
      case 1:
        currStepUI = (
          <div>
            <h2>Specifica parametri</h2>
            <form className="form">
              <div className="form-group">
                <label for="source_kit_id">Kit di provenienza</label>
                {
                  kitsDropdown.length > 0 ? (
                    <div>
                      <small className="form-text text-muted">Seleziona il kit dove cercare le richieste</small>

                      <select name="source_kit_id" className="form-control">
                        <option value="">-- sel --</option>
                        {kitsDropdown}
                      </select>
                    </div>
                  ) : (
                    <div>
                      <Spinner message="Carico kit..." />
                    </div>
                  )
                }
              </div>

              <div className="form-group">
                <label for="dest_kit_id">Kit di destinazione</label>
                {
                  kitsDropdown.length > 0 ? (
                    <div>
                      <small className="form-text text-muted">Seleziona il kit nel quale copiare le richieste</small>

                      <select name="dest_kit_id" className="form-control">
                        <option value="">-- sel --</option>
                        {kitsDropdown}
                      </select>
                    </div>
                  ) : (
                    <div>
                      <Spinner message="Carico kit..." />
                    </div>
                  )
                }
              </div>

              <hr />

              <div className="row">
                <div className="col-8">
                  <p><small className="form-text text-muted">Procedi per eseguire una simulazione e visulizzare i risultati. Potrai poi decidere se effettuare l'operazione o cambiare i parametri senza effetivamente modificare le richieste.</small></p>
                </div>
                <div className="col-4">
                  <p className="text-right">
                    <a href="javascript:void(0);" className="btn btn-primary mt-3" onClick={this.handleStep1Submit}>Vai alla simulazione <i className="fa fa-arrow-right" /></a>
                  </p>
                </div>
              </div>
            </form>
          </div>
        );
        break;

        case 2:
          if (this.state.fetching == false) {
            // calculate totals
            let stats = {
              numOrders: {
                available: this.state.currData.orders.length,
                selected: 0
              },
              numItems: {
                available: {
                  unshippable: 0,
                  shippable: 0,
                  shipped: 0
                },
                selected: {
                  unshippable: 0,
                  shippable: 0,
                  shipped: 0
                }
              },
              numKits: {
                available: {
                  unshippable: 0,
                  shippable: 0,
                  shipped: 0
                },
                selected: {
                  unshippable: 0,
                  shippable: 0,
                  shipped: 0
                }
              },
              totalNumKits: 0
            }

            this.state.currData.orders.forEach((order) => {
              order.items.forEach((item) => {
                const n = Math.ceil(item.schoolclass_num_students / this.state.fetchedData.dest_kit.num_served);

                const itemStatus = item.status.toUpperCase();

                if (!item.clone_of || this.state.allowCopied) { // only count if allowed
                  if (!item.shippable) {
                    stats.numItems.available.unshippable++;
                    stats.numKits.available.unshippable += n;

                    if (this.state.selected.indexOf(order.id) != -1) {
                      stats.numItems.selected.unshippable++;
                      stats.numKits.selected.unshippable += n;
                    }
                  }
                  if (item.shippable && itemStatus == this.STATUS_SHIPPED) {
                    if (this.state.allowShipped) { // only count if allowed
                      stats.numItems.selected.shipped++;
                      stats.numKits.selected.shipped += n;

                      if (this.state.selected.indexOf(order.id) != -1) {
                        stats.numItems.selected.shipped++;
                        stats.numKits.selected.shipped += n;
                      }
                    }
                  }
                  if (item.shippable && itemStatus != this.STATUS_SHIPPED) {
                    stats.numItems.available.shippable++;
                    stats.numKits.available.shippable += n;

                    if (this.state.selected.indexOf(order.id) != -1) {
                      stats.numItems.selected.shippable++;
                      stats.numKits.selected.shippable += n;
                    }
                  }
                }
              });
            });

            stats.totalNumKits = stats.numKits.selected.unshippable + stats.numKits.selected.shippable + stats.numKits.selected.shipped;

            currStepUI = (
              <div>
                <h2>{this.state.sourceKitName} <i className="fa fa-long-arrow-alt-right" /> {this.state.destKitName}</h2>

                <h2>Ordini ({this.state.currData.orders.length})</h2>
                <FiltersToolbar
                  filters={['schooltypes', 'locations']}
                  collapsable={true}

                  onChange={this.handleFilters}

                  data={this.state.filters}
                  appData={this.props.appData}
                />

                <div className="form-group">
                  <small className="form-text text-muted">Includi richieste gi&agrave; spedite?</small>

                  <select className="form-control" name="allow_shipped" value={this.state.allowShipped} onChange={this.handleAllowShippedChange}>
                    <option value="0">NO</option>
                    <option value="1">SI</option>
                  </select>
                </div>

                <div className="form-group">
                  <small className="form-text text-muted">Includi richieste gi&agrave; copiate?</small>

                  <select className="form-control" name="allow_copied" value={this.state.allowCopied} onChange={this.handleAllowCopiedChange}>
                    <option value="0">NO</option>
                    <option value="1">SI</option>
                  </select>
                </div>

                <hr />

                <h2>
                  Extra target: {stats.numItems.selected.unshippable} ({stats.numKits.selected.unshippable} kit) su {stats.numItems.available.unshippable} ({stats.numKits.available.unshippable} kit) disponibili<br />
                  Non spediti: {stats.numItems.selected.shippable} ({stats.numKits.selected.shippable} kit) su {stats.numItems.available.shippable} ({stats.numKits.available.shippable} kit) disponibili<br />
                  {
                    this.state.allowShipped ? (
                      <React.Fragment>
                        Spedite: {stats.numItems.selected.shipped} ({stats.numKits.selected.shipped} kit) su {stats.numItems.available.shipped} ({stats.numKits.available.shipped} kit) disponibili<br />
                      </React.Fragment>
                    ) : ''
                  }
                </h2>

                <h2 className="badge badge-success">{stats.totalNumKits} kit selezionati</h2>
                <p>
                  {
                    this.state.selected.length > 0 ? <a href="javascript:void(0);" onClick={this.deselectAll}>deseleziona tutti</a> : <a href="javascript:void(0);" onClick={this.selectAll}>seleziona tutti</a>
                  }
                </p>

                <KitOrdersList orders={this.state.currData.orders} onSelect={this.handleSelectOrder} onClear={this.handleClearOrder} selected={this.state.selected} noedit={true} />

                <hr />

                <h2>Opzioni</h2>
                <div className="form-group">
                  <label for="num_kits">Numero kit</label>
                  <small className="form-text text-muted">Quanti kit ti interessano (max. {stats.totalNumKits})?</small>

                  <input type="number" min={1} max={stats.totalNumKits} name="num_kits" className="form-control" onChange={this.handleNumKitsChange} />
                </div>

                <div className="form-group">
                  <label for="num_kits">Sposta?</label>
                  <small className="form-text text-muted">Sposta invece che copiare?</small>

                  <select className="form-control" name="allow_shipped" value={this.state.move} onChange={this.handleMoveChange}>
                    <option value="0">NO</option>
                    <option value="1">SI</option>
                  </select>
                </div>

                <hr />

                <h2>Conferma</h2>
                <div className="row">
                  <div className="col-8">
                    <p><small className="form-text text-muted">Procedi per rendere effettive le modifiche.</small></p>
                  </div>

                  <div className="col-4">
                    <p className="text-right">
                      {
                        this.state.numKits > 0 && this.state.numKits <= stats.totalNumKits ? (
                          <a href="javascript:void(0);" className="btn btn-primary mt-3" onClick={this.handleStep2Submit}><i className="fa fa-check" /> OK, procedi</a>
                        ) : (
                          <span><i className="fa fa-exclamation-triangle" /> seleziona numero kit</span>
                        )
                      }
                    </p>
                  </div>
                </div>
              </div>
            );
          } else {
            currStepUI = <Spinner message="Elaboro simulazione..." />
          }
          break;
        case 3:
          if (this.state.fetching == false) {
            currStepUI = (
              <div>
                <h2><i className="fa fa-check" /> Operazione completata.</h2>
                <p className="alert alert-success">{this.state.numCopiedKits} nuovi kit trasferiti.</p>
                {
                  Object.keys(this.state.numErrorsByMessage).length > 0 && (
                    <div className="alert alert-warning">
                      <p>ATTENZIONE: durante l'elaborazione, sono stati rivelati  errori, il numero di kit potrebbe essere inferiore alle aspettative:</p>

                      <ul>
                      {
                        Object.keys(this.state.numErrorsByMessage).map(errorMessage => (
                          <li>
                            "{errorMessage}" — {this.state.numErrorsByMessage[errorMessage]} richieste
                          </li>
                        ))
                      }
                      </ul>
                    </div>
                  )
                }
                <p><button className="btn btn-primary" onClick={this.reset}>Esegui nuova operazione</button> oppure <a href="javascript:void(0)"  onClick={(e) => {
                  this.setState({
                    fetching: true,
                    numCopiedKits: 0,
                    numJobsProcessed: 0
                  }, () => {
                    this.handleStep2Submit();
                  });
                }}>ripeti precedente</a></p>
              </div>
            );
          } else {
            currStepUI = <Spinner message={this.state.numJobsProcessed ? (' Working (' + this.state.numJobsProcessed + ' / ' +  this.state.numTotalJobs + ' operazioni eseguite)') : 'Waiting...'} />;
          }
          break;
    }

    return (
      <div className="container">
        <div className="row">
          <div className="col-12">
            <h1>Copia/incolla</h1>
            <p>Aumenta il numero di richieste in un kit copiandoli da un altro.</p>

            {
              this.state.error ? (
                <div className="alert alert-danger">
                  <h2>Oh, mamma!</h2>
                  <p>{this.state.error}</p>
                </div>
              ) : (
                <div>
                  {
                    this.state.currStep == 1 && this.state.showInstructions ? (
                      <div className="alert alert-info">
                        <button type="button" className="close" onClick={this.handleDismissInstructions}>&times;</button>

                        <h4 className="alert-heading">Come funziona</h4>
                        <p>Il sistema cercher&agrave; automaticamente richieste che risultano in target nel kit di destinazione, prediligendo le seguenti variabili nel kit di provenienza, in quest ordine: fuori target, non spediti, spediti (se richiesto), fino al raggiungimento del numero di kit specificato.</p>
                      </div>
                    ) : ""
                  }

                  {currStepUI}
                </div>
              )
            }

          </div>
        </div>
      </div>
    );
  }
}

export default CopyPastePage;


// WEBPACK FOOTER //
// ./src/pages/kit-orders/CopyPastePage.js